// extracted by mini-css-extract-plugin
module.exports = {"btnPurpleCircle":"BtnPurpleCircle_btnPurpleCircle__1FpZ8","icon":"BtnPurpleCircle_icon__3an5E","iconShare":"BtnPurpleCircle_iconShare__WA-xn"};